import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Order {
  id: string;
  carId: string;
  carInfo: {
    brand: string;
    model: string;
    plateNumber: string;
  };
  pickupDate: string;
  returnDate: string;
  pickupLocation: string;
  returnLocation: string;
  totalAmount: number;
  deposit: number;
  status: 'pending' | 'confirmed' | 'picked_up' | 'returned' | 'cancelled';
  paymentStatus: 'unpaid' | 'paid' | 'refunded';
  createdAt: string;
}

interface OrderState {
  orders: Order[];
  currentOrder: Order | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrderState = {
  orders: [],
  currentOrder: null,
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    fetchOrdersStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOrdersSuccess: (state, action: PayloadAction<Order[]>) => {
      state.loading = false;
      state.orders = action.payload;
    },
    fetchOrdersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    createOrderStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createOrderSuccess: (state, action: PayloadAction<Order>) => {
      state.loading = false;
      state.orders.unshift(action.payload);
      state.currentOrder = action.payload;
    },
    createOrderFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateOrderStatus: (state, action: PayloadAction<{ id: string; status: Order['status'] }>) => {
      const { id, status } = action.payload;
      const order = state.orders.find(o => o.id === id);
      if (order) {
        order.status = status;
      }
      if (state.currentOrder?.id === id) {
        state.currentOrder.status = status;
      }
    },
    cancelOrder: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      const order = state.orders.find(o => o.id === id);
      if (order) {
        order.status = 'cancelled';
      }
      if (state.currentOrder?.id === id) {
        state.currentOrder.status = 'cancelled';
      }
    },
  },
});

export const {
  fetchOrdersStart,
  fetchOrdersSuccess,
  fetchOrdersFailure,
  createOrderStart,
  createOrderSuccess,
  createOrderFailure,
  updateOrderStatus,
  cancelOrder,
} = orderSlice.actions;
export default orderSlice.reducer;